module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Tools/Hummer-a59474328e565599774ba8e39dd45211e3860511ba186f548c24a311e23d377a.svg";